import AirDatepicker from 'air-datepicker';
import getWindowWidth from '../utilities/getWindowWidth';

export default class Datepicker {
    constructor(element) {
        this.dates = element;

        Object.assign(this, {
            UI: {
                dateFrom: this.dates.querySelector('.js-datepicker-from'),
                dateTo: this.dates.querySelector('.js-datepicker-to'),
            },
        });

        this.initDatepickers();
        this.events();
    }

    events() {
        window.addEventListener('resize', () => {
            this.isMobileOrTablet = getWindowWidth() < 1024;
            this.datepickerFrom.update({
                isMobile: this.isMobileOrTablet,
            });
            this.datepickerTo.update({
                isMobile: this.isMobileOrTablet,
            });
        });
    }

    initDatepickers() {
        this.isMobileOrTablet = getWindowWidth() < 1024;
        const currentDate = new Date();
        let dateStartRange = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        let thirtyDaysAgo = new Date(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 дней назад

        let selectedDate;
        if (window.location.pathname.includes('personal/orders/') || window.location.pathname.includes('personal/profile-balance/')) {
            selectedDate = thirtyDaysAgo;
        } else if (window.location.pathname.includes('personal/profile-supervisor-statistics-general') || window.location.pathname.includes('personal/profile-supervisor-statistics')) {
            selectedDate = currentDate;
        } else {
            selectedDate = dateStartRange;

        }

        this.datepickerFrom = new AirDatepicker(this.UI.dateFrom, {
            inline: false,
            isMobile: this.isMobileOrTablet,
            position: 'bottom left',
            maxDate: new Date(),
            autoClose: true,
            navTitles: {
                days: '<span>MMMM</span>, <i>yyyy</i>',
            },
            onSelect: ({date}) => {
                this.datepickerTo.update({
                    minDate: date
                });
                if (this.UI.dateFrom.closest('form')) {
                    this.UI.dateFrom.closest('form').dispatchEvent(new Event('change'));
                    $(this.UI.dateFrom).closest('form').trigger('change');
                    $(this.UI.dateFrom).closest('form').trigger('change');
                }
            },
        });

        this.datepickerTo = new AirDatepicker(this.UI.dateTo, {
            inline: false,
            maxDate: new Date(),
            isMobile: this.isMobileOrTablet,
            position: 'bottom left',
            autoClose: true,
            navTitles: {
                days: '<span>MMMM</span>, <i>yyyy</i>',
            },
            onSelect: ({date}) => {
                this.datepickerFrom.update({
                    maxDate: date
                });
                if (this.UI.dateTo.closest('form')) {
                    this.UI.dateTo.closest('form').dispatchEvent(new Event('change'));
                    $(this.UI.dateTo).closest('form').trigger('change');
                }
            },
        });
    }
}
